import { Characteristic } from 'features/product-info';
import { ReviewScoreTotal } from 'features/reviews';
import { isRatingValueValid, isNumberOfRatingsValid } from 'utils/domain-specifics/reviews/validation';
import { BRAND_CHARACTERISTICS_KEY } from 'common/constants';

export const getBrandCharacteristic = (characteristics: Characteristic[] = []) => {
  const brandCharacteristics = characteristics.find(({ key }) => key === BRAND_CHARACTERISTICS_KEY);
  return brandCharacteristics?.value ?? '';
};

export const getAggregationRatings = (reviewTotalScore?: ReviewScoreTotal) => {
  const totalScore = reviewTotalScore?.score ?? null;
  const reviewsCount = reviewTotalScore?.count ?? null;
  if (
    typeof totalScore === 'number' &&
    isRatingValueValid(totalScore) &&
    typeof reviewsCount === 'number' &&
    isNumberOfRatingsValid(reviewsCount) &&
    reviewsCount > 0
  ) {
    return {
      totalScore: totalScore?.toFixed(1),
      reviewsCount: reviewsCount?.toFixed(0),
    };
  }
};
